export default {
  name: 'mw-upload-table',
  data() {
    return {
      columns: [
      ],
      fileList:[],
      accept:'',
      maxSize: 10,
      uploader:null,
      fileUploadVisible:false,
      fileUploadMsg:'',
      uploadPercent:0
    }
  },
  created() {

  },
  props: {
    action: {  //必选参数，上传的地址
      type: String,
      required: true
    },
    deleteShow:{ //是否有删除按钮
      type: Boolean,
      default: true
    },
    addShow:{ //是否有添加
      type: Boolean,
      default: true
    },
    recordsIsCanEdit:{
      type:Function
    },
    renameShow:{ //是否可以重命名
      type: Boolean,
      default: true
    },
    downloadShow:{
      type: Boolean,
      default: true
    },
    sortable:{//是否可以排序
      type: Boolean,
      default: true
    },
    multiple:{ //是否支持多选文件
      type: Boolean,
      default: true
    },
    name: {  //上传的文件字段名
      type: String,
      default: 'file'
    },
    limit:{
      type:Number
    },
    api: {  //必选参数，上传的地址
      type: String,
      required: true
    },
    defaultParams: {  //额外参数
      type: Object
    }
  },

  mounted() {
    let me=this;
    if(me.limit && me.limit==1)
        me.multiple=false;
    me.accept = PF._sysConfig && PF._sysConfig.uploadAttachFormat || "";
    me.maxSize = PF._sysConfig && PF._sysConfig.uploadAttachMaxSize || 10;
    // alert(JSON.stringify(me.defaultParams.formData))//todo
    if(me.defaultParams.accept)
      me.accept=me.defaultParams.accept;
    me.initPupload();
    let nameCol={prop: 'fileName', label: $lang('名称')};
    if(this.renameShow) nameCol.slot={type:"editableInput",func:this.rename};
    this.columns.push({type: 'selection'},{type: 'index',sortable:true},
      nameCol,
      {prop: 'mimeType', label: $lang('扩展名'),width: '80'},
      {prop: 'size', label: $lang('大小'),width: '100',formatter:this._attachFormatter});

    let showPageNum=window.$Env && $Env.attachDlgShowPageNum || false;
    if (showPageNum) {
      this.columns.push({prop: 'pageNum', label: $lang('页数'),width: '60',
        slot:{type:"editableInput",func:this.setPageNum}
      });
    }
    let showMJBS=window.$Env && $Env.attachDlgShowMJBS || false; //显示密级标识
    if(showMJBS){
      let secOptions=[{value:'',label:'无'},{value:'非密',label:'非密'},{value:'内部',label:'内部'},{value:'秘密',label:'秘密'},{value:'机密',label:'机密'}];

      // 自定义附件的密级
      if (typeof PF.setFileSecOptions == 'function') {
        // 动态附件密级
        secOptions = PF.setFileSecOptions(this.defaultParams);
      } else if(window.$Env && window.$Env.secOptions){
        // 静态附件密级
        secOptions = window.$Env.secOptions;
      } else {
        let secLevel=this.defaultParams.secLevel;
        // alert(me.secLevel)
        if(secLevel=="机密"||secLevel=="1"){

        }else if(secLevel=="秘密"||secLevel=="2"){
          secOptions=secOptions.slice(0,4);
        }else if(secLevel=="内部"||secLevel=="4"){
          secOptions=secOptions.slice(0,3);
        }else{
          secOptions=secOptions.slice(0,2);
        }
      }
      this.columns.push({prop: 'fldmjbs', label: $lang('密级'),width: '80',
        slot:{type:"editableSelect",func:this.setMJBS,options:secOptions, formatter: this.mjbsFormatter}
      });
    }

    if(this.sortable==true){}
     this.mwRef('table').sortable();
  },
  watch: {
    'defaultParams.tempBusinessId'(val) {
      this.mwRef('table').refresh()
    },
    'defaultParams.businessId'(val) {
      this.mwRef('table').refresh()
    }
  },
  methods: {
    initPupload(){
      let me=this;
      PF.requireJs(["/assets/js/Plupload/js/plupload.full.min.js"],function(){
        var cfg={
          runtimes : 'gears,html5,flash,silverlight,browserplus,html4',
          browse_button : me.mwRef('uploader').$el, //选择文件按钮ID
          max_file_size : me.maxSize+'mb',  //文件上传最大值
          unique_names : true,  // 上传的文件名是否唯一,只有在未进行分块上传时文件名唯一才有效
          url :me.action ,//提交到后台的url地址
          multi_selection: me.multiple, //能否多选
          flash_swf_url : '/assets/js/Plupload/js/Moxie.swf',//plupload.flash.swf文件所在路径
          silverlight_xap_url : '/assets/js/Plupload/js/Moxie.xap'//silverlight所在路径
        }
        if(me.accept){
          cfg.filters={mime_types:[
              {title : $lang("自定义文件"), extensions : me.accept}
            ] }
        }
        var uploader = new plupload.Uploader(cfg);
        me.uploader=uploader;
        uploader.bind('FilesAdded', function (up, files) {
          let isOverlong = 0;
          files.forEach((v)=>{
            let nativecode = v.name.split("");
            let len = 0;
            for (let i = 0; i < nativecode.length; i++) {
              var code = Number(nativecode[i].charCodeAt(0));
              if (code > 127) {
                len += 2;
              } else {
                len++;
              }
            }
            if(len>255) {
              isOverlong += 1;
            }
          })
          if(isOverlong) {
            me.$message.error(isOverlong + $lang("个文件的文件名过长，请重新上传"));
            files.forEach((v)=>{
              up.removeFile(v);
            })
            return;
          }

          //up.files 文件删除后没有把up里的文件删掉，所以用 me.fileList
          if(me.limit && me.limit!=0 && me.fileList.length>=me.limit) {
            me.$message.error($lang("最多只能上传")+me.limit+$lang("个文件!"));
            files.forEach((v)=>{
                up.removeFile(v);
            })
            return;
          }
          var fgwjList = {};
          if(me.fileList.length > 0){
            files.forEach((v)=>{
              var fj = _.find(me.fileList,function(f){return f.name == v.name});
              if(fj){
                fgwjList[fj.name] = fj.id;
              }
            })
          }
          me.defaultParams.fullPath="y";
          if(!_.isEmpty(fgwjList)){
            let fileNames = []
            _.mapKeys(fgwjList,function(i,n){fileNames.push(n)});
            PF.confirm($lang("文件名称")+"["+fileNames+"]"+$lang("已存在，是否覆盖")).then(()=>{
              me.defaultParams.fjwjList = PF.encode(fgwjList);
              uploader.setOption("multipart_params",me.defaultParams);
              uploader.start();
            }).catch(()=>{
              uploader.setOption("multipart_params",me.defaultParams);
              uploader.start();
            });
          }else{
            uploader.setOption("multipart_params",me.defaultParams);
            uploader.start();
          }
        });
        uploader.bind('UploadProgress',function(up, file) {
          me.fileUploadVisible = true;
          me.uploadPercent=parseInt(file.percent.toFixed(0));
          me.fileUploadMsg = '当前上传文件: '+file.name;
        });
        uploader.bind('UploadComplete',function(up, files) {
          me._uploadSuccess(up,files);
        });
        uploader.bind('Error', function(up, err) {
          if(err.response){
            var response=JSON.parse(err.response);
            if(response && response.result){
              me.$message.warning(response.result.msg);
            }
          }else {
            if (err.message.indexOf("File size error") != -1)
              me.$message.error($lang('上传附件大小不能超过') + me.maxSize + 'MB!');
            else if (err.message.indexOf("File extension error") != -1)
              me.$message.error($lang("只能上传文件类型:") + " " + me.accept + $lang("的文件"));
            else
              me.$message.warning(err.code + ":" + err.message + (err.file ? ", File: " + err.file.name : ""));
          }
          up.refresh();

        });
        uploader.init();
      });
    },
    downloadAttachment(){
      let sel=this.mwRef('table').getMultipleSelection();
      if(sel.length==0){
        this.mwMsg('info', $lang('请选择需要下载的记录'));
        return;
      }
      if(sel.length>1){
        this.mwMsg('info', $lang('只能单个文件下载'));
        return;
      }
      let params=Object.assign({id:sel[0].id},this.defaultParams)
      if(params.formData) delete params.formData;
      this.mwApi.business.downloadAttachment(params)
      //window.open("/api/business/downloadAttachment?attachId="+sel[0].attachId+"&xToken="+token.getToken());
    },
    downloadAllAttachment(){
      let params=Object.assign({},this.defaultParams);
      if(params.formData) delete params.formData;
      this.mwApi.business.downloadAttachments(params);
      //window.open("/api/business/downloadAttachment?attachId="+sel[0].attachId+"&xToken="+token.getToken());
    },
    deleteAttachment(){
      let sel=this.mwRef('table').getMultipleSelection();
      if(sel.length==0){
        this.mwMsg('info', $lang('请选择需要删除的记录'));
        return;
      }
      if(this.recordsIsCanEdit){
        if(this.recordsIsCanEdit(sel)===false) return;
      }
      let ids=[];
      sel.map((v)=>{
        ids.push(v.id);
      })

      this.mwApi.business.deleteAttachment(Object.assign({attachIds:ids},this.defaultParams)).then(()=>{
        this.fileUploadVisible = false;
        this.uploadPercent = 0;
        this.mwRef('table').refresh()
      });
    },
    _tableDataLoaded(data){
      this.fileList = data || [];
      this.$emit('dataLoaded',data);
    },
    _attachFormatter(row, column, cellValue){
      return (cellValue/1024).toFixed(2)+'K';
    },
    _uploadSuccess(up,fileList){
      // this.fileUploadVisible = false;
      // this.uploadPercent = 0;
      this.mwRef('table').refresh();
    },
    _sortableUpdate(changes) {
      let dataList=this.$refs.table.dataList;
      //强制组件排序从1开始耗能递增，不需要使用changes;
      let indexMap={};
      for (let i = 0; i < dataList.length; i++) {
        let d=dataList[i];
        if (d.sn !== i) {
          indexMap[d.id]=i;
        }
      }
      if (!$.isEmptyObject(indexMap)) {
        let params=Object.assign({indexMap:indexMap},this.defaultParams)
        PF.fsrv("business.srv.updateAttachmentSn", params).then(res => {
          if (res.success) {
            for (let i = 1; i < dataList.length; i++) {
              let d=dataList[i];
              d.sn=i;
            }
            this.mwRef('table').refresh()
          }
        });
      }
    },
    rename(row,table,index){
      if(!row.fileName) {
        this.$message.error($lang('文件名不能为空'));
        return;
      }
      if(this.recordsIsCanEdit){
        if(this.recordsIsCanEdit([row])===false) return;
      }
      let params=Object.assign({attachId:row.id,name:row.fileName+row.mimeType},this.defaultParams)
      this.mwApi.business.updateAttachment(params).then(r => {
        table.refresh();
      })
    },
    setPageNum(row,table,index) {
      let params=Object.assign({attachId:row.id,pageNum:row.pageNum},this.defaultParams)
      this.mwApi.business.updateAttachment(params).then(r => {
        table.refresh();
      })
    },
    setMJBS(row,table,index) {
      let params=Object.assign({attachId:row.id,fldmjbs:row.fldmjbs},this.defaultParams)
      this.mwApi.business.updateAttachment(params).then(r => {
        table.refresh();
      })
    },
    mjbsFormatter(row, column, cellValue){
      if ($.isFunction(PF.mjbsFormatter)) {
        return PF.mjbsFormatter(cellValue);
      }
      return cellValue;
    },
    format(percentage) {
       return parseInt(percentage) === 100 ? '成功' : `${percentage}%`;
     },
  },
  render() {
    let {action,multiple,name,limit,api,columns,defaultParams,accept,maxSize,
         downloadAttachment,downloadAllAttachment,addShow,deleteShow,renameShow,downloadShow,deleteAttachment,_tableDataLoaded,_sortableUpdate,fileUploadVisible,uploadPercent,format,fileUploadMsg} =this

    let addBtn;
    if(addShow)
      addBtn=<el-button type="default" ref="uploader"><i  class="fa fa-plus-square fa-fw"></i>{$lang('添加')}</el-button>

    let deleteBtn;
    if(deleteShow)
      deleteBtn=<el-button type="default"   onClick={deleteAttachment}><i  class="fa fa-trash-o fa-fw"></i>{$lang('删除')}</el-button>

    let downloadBtn;
    if(downloadShow)
      downloadBtn = <div style="float:right;">
        <el-button type="default" onClick={downloadAttachment}><i className="fa fa-download fa-fw"></i>{$lang('下载')}</el-button>
        <el-button type="default" onClick={downloadAllAttachment}><i className="fa fa-download fa-fw"></i>{$lang('下载全部')}</el-button>
      </div>
    let percentTpl;
    if(fileUploadVisible)
      percentTpl=<div style="margin-top:0px;">
        <div style="line-height:12px;text-align:center;font-size:12px;width:100%;margin-top:0px;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{fileUploadMsg}</div>
        <el-progress  percentage={uploadPercent} format={format} style="margin-top:0px;"></el-progress>
       </div>
    else
      percentTpl="";
    return (
<div class="mw-upload">
  <div class="mw-toolbar">
      {addBtn}
    {deleteBtn}
    {downloadBtn}
  </div>
  <div class="mw-toolbar__body" style="height:calc(100% - 150px);">
    <mw-table api={api} ref="table"  onSortableUpdate={_sortableUpdate} onDataLoaded={_tableDataLoaded} pagination={false} columns={columns} defaultParams={defaultParams}>
      </mw-table>
  </div>
  <div style="padding-top: 15px;color: black;">
    {percentTpl}
    <el-tooltip className="item" effect="dark" content={accept} placement="top-start">
      <div style="width: 95%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{$lang('支持格式')}：{accept?accept:"所有"}。</div>
    </el-tooltip>
    <el-tooltip className="item" effect="dark" content={maxSize} placement="top-start">
      <div style="width: 95%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{$lang('上传大小')}：不超过{maxSize}MB。</div>
    </el-tooltip>
  </div>
</div>

    )
  }
}







// WEBPACK FOOTER //
// ./src/common/components/extend/upload/uploadTable.js